import styled from 'styled-components';
import Page from '../components/Page';

const DecisioningContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items:center;
  width:100%;
`;
const ApprovedContainer = styled.div`
  width:200px;
  height:200px;
`;
const DecisioningText = styled.p`${({ theme }) => `
  color:${theme.primary};
  font-size: ${theme.fontSize[11]};
  font-weight: ${theme.fontWeight.bold};
`}`;

export default function DownloadESIS() {
  return (
    <Page>
      <DecisioningContainer id="DecisioningContainer">
        <ApprovedContainer>
          <i className="mi-check" />
        </ApprovedContainer>
        <DecisioningText>Download ESIS</DecisioningText>
      </DecisioningContainer>
    </Page>
  );
}
